import { Grid } from '@mui/material';

const DetailsSection = ({ children }) => {
  return (
    <Grid container spacing={1}>
      {children}
    </Grid>
  );
};

export default DetailsSection;
